export default __webpack_public_path__ + "static/media/complementary--except-bicycles--g2.64490d3f.png";